import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant';

import 'vant/lib/index.css';
import "@/assets/iconfont/iconfont.css";
import "@/assets/css/style.css";
import '@/assets/iconfont/iconfont.js';
import logo from '@/assets/logo.jpg';
import { getToken, getExpTime, getGUID } from '@/Utils/auth';
import { GetJSSDK } from "@/api/weixin";
import { AddPV } from '@/api/public'
import wx from 'weixin-js-sdk';
import qrcode from 'vue-qrcode-directive'
Vue.use(qrcode);
Vue.use(Vant);
Vue.config.productionTip = false

var times = 0;
var ExpTime = getExpTime();
var timer;
if (ExpTime != null) {
  times = (ExpTime - (new Date().getTime()) / 1000);
  timer = setInterval(() => {
    times--;
    if (times < 86400) {
      if (times < 0) {
      } else {
        store.dispatch('RefreshToken')
          .then(res => {
            console.log('res :>> ', res);
            times = (res - (new Date().getTime()) / 1000);
          });
      }
    }
  }, 1000);
}

GetJSSDK({ url: window.location.href }).then(res => {
  let data = res.OtherMsg;
  wx.config({
    debug: false,//这里一般在测试阶段先用ture，等打包给后台的时候就改回false,
    appId: data.AppId,
    timestamp: data.Timestamp,
    nonceStr: data.NonceStr,
    signature: data.Signature,
    jsApiList: ['chooseWXPay', 'updateAppMessageShareData', 'updateTimelineShareData', 'scanQRCode']
  })
});
//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {

  let GUID = ''
  try {
    GUID = getGUID();
  } catch (error) {
    console.log('生成GUID出错 :>> ', error);
    GUID = new Date().getTime();
  }
  let PV = {
    UserID: 0,
    Guid: GUID,
    LoginTime: new Date(),
    LeaveTime: new Date(),
    Referrer: '',
    LinkUrl: location.href
  };

  AddPV(PV).then().catch(err => {

    console.log(err)
  })

  times = (getExpTime() - (new Date().getTime()) / 1000);
  if (timer == undefined) {
    timer = setInterval(() => {
      times--;
      if (times < 86400) {
        if (times < 0) {
        } else {
          store.dispatch('RefreshToken')
            .then(res => {
              times = (res - (new Date().getTime()) / 1000);
            });
        }
      }
    }, 1000);
  }
  let title = to.meta && to.meta.title && to.meta.title != '' ? to.meta.title : '黔音在线';
  let link = to.meta && to.meta.url && to.meta.url != '' ? (window.location.protocol + "//" + window.location.host + to.meta.url) : window.location.href;
  let desc = to.meta && to.meta.digest && to.meta.digest != '' ? to.meta.digest : '贵州省音乐家协会【黔音在线】通过全新系统的改版建设，帮助协会发布考级通知、考生在线报名、在线考试、考官在线评审、考生证书邮寄等功能的综合业务系统以及贵州省音协的各项工作动态和成果。';
  let imgUrl = to.meta && to.meta.img && to.meta.img != '' ? to.meta.img : (window.location.protocol + "//" + window.location.host + '/' + logo);
  //配置全局微信分享
  wx.ready(function () {
    wx.updateTimelineShareData({
      title: title, // 分享标题
      link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: imgUrl, // 分享图标
      success: function () {
        console.log("分享成功");
      }
    });
    wx.updateAppMessageShareData({
      title: title, // 分享标题
      link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: imgUrl, // 分享图标
      desc: desc, // 分享索引
      success: function () {
        console.log("分享成功");
      }
    });
  });

  if (to.meta.isAuth === true && !getToken() && to.path !== '/login') {
    next('/login');
  } else {
    // 简单的判断IE10及以下不进入富文本编辑器，该组件不兼容
    if (navigator.userAgent.indexOf('MSIE') > -1 && to.path === '/editor') {
      Vue.prototype.$alert('vue-quill-editor组件不兼容IE10及以下浏览器，请使用更高版本的浏览器查看', '浏览器不兼容通知', {
        confirmButtonText: '确定'
      });
    } else {
      next();
    }
  }
});


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
